import { Activityeditor } from '@linktivity/link-connect';
import config from '../config';

const taskApi = new Activityeditor.TaskApi(config);

export default taskApi;
